import React from "react";
import { useTranslation } from "react-i18next";
import CssBaseline from "@mui/material/CssBaseline";
import { NoSsr, useMediaQuery, useTheme } from "@mui/material";
import { useRouter } from "../../helper-functions/useRouterReplacement";
import MetaData from "../meta-data";
import MainLayout from "../../components/layout/MainLayout";
import AuthGuard from "../../components/route-guard/AuthGuard";
import ProductSearchPage from "../../components/search";
import HomeSearch from "../../components/search/HomeSearch";
import useConfigData from "../../hooks/useConfigData";
import SearchHeroSection from "../../components/search/SearchHeroSection";

import SEO from "../../components/seo";

const Index = () => {
  const { configData, landingPageData, loading } = useConfigData();
  const { t } = useTranslation();
  const router = useRouter();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  
  let token = undefined;
  if (typeof window !== "undefined") {
    token = localStorage.getItem("token");
  }
  let zoneid = undefined;
  if (typeof window !== "undefined") {
    zoneid = localStorage.getItem("zoneid");
  }

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }

  return (
    <>
      <CssBaseline />
      <SEO
        title={configData ? `Search` : "Loading..."}
        image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
        businessName={configData?.business_name}
      />
      <MainLayout configData={configData} landingPageData={landingPageData}>
        <NoSsr>
          <SearchHeroSection configData={configData} token={token} zoneid={zoneid} />
          <ProductSearchPage configData={configData} token={token} />
        </NoSsr>
      </MainLayout>
    </>
  );
};

export default Index;
